import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import CustomTable from 'src/components/PostGraduationContent/PostgraduateComponents/Table/CustomTable'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { DISCIPLINES } from './Disciplines.data'
import { useStyles } from './Disciplines.styles'

const Disciplines = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const tableRows = DISCIPLINES.map((discipline) => [
    discipline.name,
    ('0' + discipline.cred).slice(-2),
    `${discipline.work} horas`
  ])

  return (
    <>
      <Typography className={globalClasses.titleSectionVariant2}>
        {t('news.postgraduate.disc.tab-title')}
      </Typography>
      <Box className={classes.contentContainer}>
        <Typography className={classes.paragraph}>
          {t('news.postgraduate.disc.p1')}
        </Typography>
        <Box className={classes.tableContainer}>
          <CustomTable
            headers={[
              t('news.postgraduate.disc.tab-title'),
              t('news.postgraduate.disc.cred'),
              t('news.postgraduate.disc.hours')
            ]}
            rows={tableRows}
            highlightLastRow
            centerColumns={[1, 2]}
          />
        </Box>
      </Box>
    </>
  )
}

export default Disciplines
